import { useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function LoanApplication() {
  const { state } = useLocation();
  const { carName, loanAmount, initialDeposit, loanPeriod, monthlyRepayment } = state || {};
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    age_bracket: '',
    income_range: '',
    client_location: '',
    client_id: '',
    bvn_available: '',
    deposit_available: '',
    employment_status: '',
    referral: '',
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/client-info`, formData);
      alert('Application submitted successfully!');
      navigate('/financing');
    } catch (err) {
      console.error('Error submitting client info:', err.message);
      alert('Failed to submit application');
    }
  };

  const formatValue = (value) => {
    return value.toLocaleString('en-NG', { maximumFractionDigits: 2 });
  };

  if (!state) return <div className="text-center py-10">No loan details available.</div>;

  return (
    <div className="bg-gradient-to-b from-gray-100 to-blue-100 text-gray-800 min-h-screen">
      <Navbar />
      <div className="container mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold mb-6 text-blue-900">Loan Application</h1>
        <div className="bg-white p-6 rounded-lg shadow-md mb-6">
          <h2 className="text-xl font-semibold mb-4">Loan Details</h2>
          <p>Car Name: {carName}</p>
          <p>Price: ₦{formatValue(loanAmount)}</p>
          <p>Initial Deposit: ₦{formatValue(initialDeposit)}</p>
          <p>Loan Period: {loanPeriod}</p>
          <p>Monthly Repayment: ₦{formatValue(monthlyRepayment)}</p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-xl font-semibold mb-4">Client Information</h2>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Full Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Phone</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                className="w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Age Bracket</label>
              <select
                name="age_bracket"
                value={formData.age_bracket}
                onChange={handleChange}
                required
                className="w-full p-2 border border-gray-300 rounded-md"
              >
                <option value="">Select Age Bracket</option>
                <option value="18 - 25">18 - 25</option>
                <option value="26 - 35">26 - 35</option>
                <option value="36 - 60">36 - 60</option>
                <option value="60 & Above">60 & Above</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Monthly Income Range</label>
              <select
                name="income_range"
                value={formData.income_range}
                onChange={handleChange}
                required
                className="w-full p-2 border border-gray-300 rounded-md"
              >
                <option value="">Select Income Range</option>
                <option value="Less than 100k">Less than 100k</option>
                <option value="100k - 199k">100k - 199k</option>
                <option value="200k - 299k">200k - 299k</option>
                <option value="300k - 399k">300k - 399k</option>
                <option value="400k - 800k">400k - 800k</option>
                <option value="800k & Above">800k & Above</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Your Location</label>
              <input
                type="text"
                name="client_location"
                value={formData.client_location}
                onChange={handleChange}
                required
                className="w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Do you have an ID?</label>
              <select
                name="client_id"
                value={formData.client_id}
                onChange={handleChange}
                required
                className="w-full p-2 border border-gray-300 rounded-md"
              >
                <option value="">Select</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Do you have BVN?</label>
              <select
                name="bvn_available"
                value={formData.bvn_available}
                onChange={handleChange}
                required
                className="w-full p-2 border border-gray-300 rounded-md"
              >
                <option value="">Select</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Do you have the Initial Deposit Amount?</label>
              <select
                name="deposit_available"
                value={formData.deposit_available}
                onChange={handleChange}
                required
                className="w-full p-2 border border-gray-300 rounded-md"
              >
                <option value="">Select</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Employment Status</label>
              <select
                name="employment_status"
                value={formData.employment_status}
                onChange={handleChange}
                required
                className="w-full p-2 border border-gray-300 rounded-md"
              >
                <option value="">Select</option>
                <option value="Unemployed">Unemployed</option>
                <option value="Employed">Employed</option>
                <option value="Business Owner">Business Owner</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">How did you hear about us?</label>
              <input
                type="text"
                name="referral"
                value={formData.referral}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
            <button
              type="submit"
              className="bg-green-600 text-white p-2 rounded-md hover:bg-green-700 w-full"
            >
              Submit Application
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}